import PropTypes from 'prop-types';

import { cn } from 'utils';

export const RButtonVariants = {
  outline: 'outline',
  outlineBordered: 'outlineBordered',
  small: 'small',
  smallOutlineBordered: 'smallOutlineBordered',
  text: 'text',
};

export function Loader({ className, ...props }) {
  return (
    <img
      className={cn('animate-rotate', className)}
      alt=""
      {...props}
    />
  );
}

Loader.propTypes = {
  className: PropTypes.string,
};
